
namespace GeniuzPOS.PriceChange {
    import fld = ActivePriceChangeRow.Fields;
    @Serenity.Decorators.registerClass()
    export class ActivePriceChangeGrid extends Serenity.EntityGrid<ActivePriceChangeRow, any> {
        protected getColumnsKey() { return ActivePriceChangeColumns.columnsKey; }
        protected getDialogType() { return ActivePriceChangeDialog; }
        protected getIdProperty() { return ActivePriceChangeRow.idProperty; }
        protected getInsertPermission() { return ActivePriceChangeRow.insertPermission; }
        protected getLocalTextPrefix() { return ActivePriceChangeRow.localTextPrefix; }
        protected getService() { return ActivePriceChangeService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
    
            // this.slickContainer.on('change', '.edit:input', (e) => this.inputsChange(e));
        }
        protected getButtons() {
            var buttons = super.getButtons();
            buttons.splice(Q.indexOf(buttons, x => x.cssClass == 'column-picker-button'), 1)
            buttons.splice(Q.indexOf(buttons, x => x.cssClass == 'add-button'), 1)
            
            buttons.push(
                {
                    title: Q.text("Close"), // *** Get button text from translation
                    cssClass: '.panel-titlebar-close',
                    icon: 'fa-close',
                    onClick: () => {
                        window.location.href = '/';
                        return false;
                    },
                }
            );            
            return buttons;
        }
        protected getQuickFilters(): Serenity.QuickFilter<Serenity.Widget<any>, any>[] {

            let filters = super.getQuickFilters();
            // Q.first(filters, x => x.field == fld.ApproveFg).init = w => {
            //     (w as Serenity.EnumEditor).value = "1";
            //     ;
            // };
            Q.first(filters, x => x.field == fld.PostFg).init = w => {
                (w as Serenity.EnumEditor).value = "0";
                 ;
            };   
            
            
            return filters;
        }
        protected createToolbarExtensions() {
            super.createToolbarExtensions();
    
            this.slickGrid.registerPlugin(new Slick.Data.GroupItemMetadataProvider());
                
            var groupingMixin = new Serenity.DraggableGroupingMixin({
                grid: this
            });
    
            // setting ShipCountry, ShipCity columns as initially grouped for this sample
            // you could add [GroupOrder(1)] to ShipCountry, and [GroupOrder(2)] to ShipCity
            // in OrderColumns.cs instead (recommended way)
            groupingMixin.plugin.setDroppedGroups(["  "]);
        }
        protected getSlickOptions() {
            var opt = super.getSlickOptions();
            // need to turn grouping panel ON for drag drop grouping to work properly
            opt.groupingPanel = true;
            return opt;
        } 
    }
}